export const svgHeight = 125
export const illustrationHeight: number = svgHeight + 22 // 22 for the typography
export const triggerHeight: number = illustrationHeight + 20
export const maxHeight: number = illustrationHeight * 1.25
